// import { deleteStoresData } from 'services/db/sqlite';
import lastUsedConversation from 'utils/lastUsedConversation';
import { useDeleteConversation } from '../lruConversation';
import { useConversationSummaryList } from '../conversation';

const useShops = () => {
  const deleteConversation = useDeleteConversation();
  const conversationSummaryList = useConversationSummaryList();

  const deleteStateData = (storeList: string[]) => {
    const waitDelIds = conversationSummaryList
      .filter((conversation) => storeList.includes(conversation.storeId))
      .map((con) => con.conversationId);
    deleteConversation(waitDelIds);
    waitDelIds.forEach((id) => {
      lastUsedConversation.remove(id);
    });
  };

  // 删除本地数据库和缓存店铺
  const deleteStoreById = (storeId: string | number) => {
    const id = typeof storeId === 'number' ? storeId.toString() : storeId;
    if (storeId) {
      // deleteStoresData([id]);
      deleteStateData([id]);
    }
  };

  return {
    deleteStateData,
    deleteStoreById,
  };
};

export default useShops;
